import { useState, useEffect } from 'react';
import { Eye } from 'lucide-react';
import axios from 'axios';
import { API } from '@/App';

const PropertyViewCounter = ({ propertyId, showLabel = true, className = '' }) => {
  const [views, setViews] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!propertyId) return;
    
    const fetchViews = async () => {
      try {
        const res = await axios.get(`${API}/properties/${propertyId}/views?days=7`);
        setViews(res.data.views);
      } catch (error) {
        console.error('Error fetching views:', error);
        setViews(0);
      } finally {
        setLoading(false);
      }
    };

    fetchViews();
  }, [propertyId]);

  // Track view when component mounts (only once per session)
  useEffect(() => {
    if (!propertyId) return;
    
    const viewKey = `ikonic_viewed_${propertyId}`;
    const alreadyViewed = sessionStorage.getItem(viewKey);
    
    if (!alreadyViewed) {
      axios.post(`${API}/properties/${propertyId}/view`).catch((error) => {
        // View tracking is non-critical, log silently
        if (process.env.NODE_ENV === 'development') {
          console.error('View tracking failed:', error.message);
        }
      });
      sessionStorage.setItem(viewKey, 'true');
    }
  }, [propertyId]);

  if (loading || views === null) return null;
  if (views === 0) return null;

  return (
    <div 
      className={`flex items-center gap-1 text-[#A3A3A3] ${className}`}
      title={`${views} personas vieron esta propiedad esta semana`}
    >
      <Eye size={14} className="text-[#D4AF37]" />
      <span className="text-xs">
        {showLabel ? (
          views === 1 
            ? '1 persona vio esto esta semana' 
            : `${views} personas vieron esto esta semana`
        ) : (
          views
        )}
      </span>
    </div>
  );
};

// Badge version for PropertyCard
export const ViewCountBadge = ({ propertyId }) => {
  const [views, setViews] = useState(null);

  useEffect(() => {
    if (!propertyId) return;
    
    const fetchViews = async () => {
      try {
        const res = await axios.get(`${API}/properties/${propertyId}/views?days=7`);
        setViews(res.data.views);
      } catch (error) {
        setViews(0);
      }
    };

    fetchViews();
  }, [propertyId]);

  if (views === null || views < 3) return null; // Only show if 3+ views

  return (
    <div 
      className="absolute top-3 right-3 bg-black/70 text-white text-xs px-2 py-1 rounded-full flex items-center gap-1 backdrop-blur-sm"
      title={`${views} vistas esta semana`}
    >
      <Eye size={12} />
      <span>{views}</span>
    </div>
  );
};

export default PropertyViewCounter;
